import React, {useState, useEffect} from "react";
import axios from "axios";
import {Link, useParams} from "react-router-dom";
import {useSelector} from "react-redux";
import Button from "react-bootstrap/Button";
import {Col, Collapse, Row} from "react-bootstrap";
import Moment from "moment";

const SearchResults = () => {

    const [client, setClient] = useState([""])
    const [presite, setPresite] = useState([""])
    const [onSite, setOnSite] = useState([""])
    const [proposal, setProposal] = useState([""])
    const [invoice, setInvoice] = useState([""])
    const [workOrder, setWorkOrder] = useState([""])
    const [checklist, setCheckList] = useState([""])
    const [workHours, setWorkHours] = useState([''])
    const [priority, setPriority] = useState(['']);

    const [loading, setLoading] = useState(false)

    const [clientOpen, setClientOpen] = useState(false);
    const [preSiteOpen, setPreSiteOpen] = useState(false);
    const [onSiteOpen, setOnSiteOpen] = useState(false);
    const [proposalOpen, setProposalOpen] = useState(false);
    const [invoiceOpen, setInvoiceOpen] = useState(false);
    const [workOrderOpen, setWorkOrderOpen] = useState(false);
    const [checklistOpen, setChecklistOpen] = useState(false);
    const [hoursWorkedOpen, setHoursWorkedOpen] = useState(false);
    const [priorityOpen, setPriorityOpen] = useState(false);

    const {id} = useParams()

    const userLogin = useSelector(state => state.userLogin)
    const {userInfo} = userLogin


    const getData = async () => {
        setLoading(true)
        try {
            let clients = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/clients/${id}/`, {
            // let clients = await axios.get(`http://127.0.0.1:8000/api/clients/${id}/`, {
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${userInfo.token}`
                }})
            setClient(clients.data)
        }
        catch (err){
            if (err.response){
                console.log(err.response)
                setClient('None')
            } else if (err.request) {
                console.log(err.request)
                setClient('None')
            }
        }
        try {
            let presite = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/presite/${id}/`, {
            // let presite = await axios.get(`http://127.0.0.1:8000/api/presite/${id}/`, {
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${userInfo.token}`
                }})
            setPresite(presite.data)
        }
        catch (err){
            if (err.response){
                console.log(err.response)
                setPresite('None')
            } else if (err.request) {
                console.log(err.request)
                setPresite('None')
            }
        }
        try {
            let onsite = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/onsite/${id}/`, {
            // let onsite = await axios.get(`http://127.0.0.1:8000/api/onsite/${id}/`, {
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${userInfo.token}`
                }})
            setOnSite(onsite.data)
        }
        catch (err){
            if (err.response){
                console.log(err.response)
                setOnSite('None')
            } else if (err.request) {
                console.log(err.request)
                setOnSite('None')
            }
        }
        try {
            let proposal = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/proposals/${id}/`, {
            // let proposal = await axios.get(`http://127.0.0.1:8000/api/proposals/${id}/`, {
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${userInfo.token}`
                }})
            setProposal(proposal.data)
        }
        catch (err){
            if (err.response){
                console.log(err.response)
                setProposal('None')
            } else if (err.request) {
                console.log(err.request)
                setProposal('None')
            }
        }
        try {
            let invoice = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/invoices/${id}/`, {
            // let invoice = await axios.get(`http://127.0.0.1:8000/api/invoices/${id}/`, {
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${userInfo.token}`
                }})
            setInvoice(invoice.data)
        }
        catch (err){
            if (err.response){
                console.log(err.response)
                setInvoice('None')
            } else if (err.request) {
                console.log(err.request)
                setInvoice('None')
            }
        }
        try {
            let workOrder = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/workorders/${id}/`, {
            // let workOrder = await axios.get(`http://127.0.0.1:8000/api/workorders/${id}/`, {
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${userInfo.token}`
                }})
            setWorkOrder(workOrder.data)
        }
        catch (err){
            if (err.response){
                console.log(err.response)
                setWorkOrder('None')
            } else if (err.request) {
                console.log(err.request)
                setWorkOrder('None')
            }
        }
        try {
            let checkList = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/check_list/${id}/`, {
            // let checkList = await axios.get(`http://127.0.0.1:8000/api/check_list/${id}/`, {
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${userInfo.token}`
                }})
            setCheckList(checkList.data)
        }
        catch (err){
            if (err.response){
                console.log(err.response)
                setCheckList('None')
            } else if (err.request) {
                console.log(err.request)
                setCheckList('None')
            }
        }
        try {
            let workHours = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/clienthours/${id}/`, {
            // let workHours = await axios.get(`http://127.0.0.1:8000/api/clienthours/${id}/`, {
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${userInfo.token}`
                }})
            setWorkHours(workHours.data)
        }
        catch (err){
            if (err.response){
                console.log(err.response)
                setWorkHours('None')
            } else if (err.request) {
                console.log(err.request)
                setWorkHours('None')
            }
        }
        try {
            let priority = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/priority_reports/${id}/`, {
            // let priority = await axios.get(`http://127.0.0.1:8000/api/priority_reports/${id}/`, {
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${userInfo.token}`
                }})
            setPriority(priority.data)
        }
        catch (err){
            if (err.response){
                console.log(err.response)
                setPriority('None')
            } else if (err.request) {
                console.log(err.request)
                setPriority('None')
            }
        }
        setLoading(false)
    }

    let redirect = ''
    if (userInfo){
        if (userInfo.group === "AdminSuper"){
            redirect = '/active_work_orders'
        } else if (userInfo.group === "Finance") {
            redirect = '/finance_active_work_orders'
        } else if (userInfo.group === "Logistics") {
            redirect = '/logistics_active-work_orders'
        } else if (userInfo.group === "Tech") {
            redirect = '/tech_work_orders'
        }
    }


    useEffect(() => {
        getData()
    }, [])

    return (
        <div>
            <Link style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop:'5px'
            }} className={'btn btn-primary'} to={redirect}>Active Work Orders Dashboard</Link>
            <br />
            <br />

            <h1>Client Information For: {client.work_site_address}</h1>
            <br/>
            <div>
                {
                    loading
                        ?
                        (
                            <h4>
                                Loading...
                            </h4>
                        )
                        :
                        (
                            <div>
                                <Row>
                                    <Col>
                                        {userInfo.group !== 'Tech'
                                            ?
                                            (
                                                <div>
                                                    <Button
                                                        onClick={() => setClientOpen(!clientOpen)}
                                                        aria-controls="example-collapse-text"
                                                        aria-expanded={clientOpen}
                                                        className={'btn btn-primary'}
                                                    >
                                                        Client Details
                                                    </Button>

                                                    <br/>

                                                    <Collapse in={clientOpen} className={'collapse-area'}>
                                                        <div id="example-collapse-text">
                                                            <h3>Client Details:</h3>
                                                            <p>Work Site Address: {client.work_site_address}</p>
                                                            <p>Details For Address: {client.details_for_address}</p>
                                                            <p>Project ID: {client.project_ID}</p>
                                                            <p>Referral Name: {client.referral_name}</p>
                                                            <p>Phone: {client.phone}</p>
                                                            <p>Email: {client.email}</p>
                                                            <p>Service Order: {client.service_order}</p>
                                                            <p>Client Name: {client.client_name}</p>
                                                            <p>Client Phone: {client.client_phone}</p>
                                                            <p>Organization's Name: {client.organization_name}</p>
                                                            {
                                                                client.new_client === "Yes"
                                                                    ?
                                                                    (<p style={{
                                                                        background: 'red',
                                                                        color: 'white'
                                                                    }}>New Client: {client.new_client}</p>)
                                                                    :
                                                                    (<p>New Client: {client.new_client}</p>)
                                                            }
                                                            <p>From Where: {client.from_where}</p>
                                                            <p>From Where
                                                                Description: {client.from_where_description}</p>
                                                            <p>Requested Service: {client.requested_service}</p>
                                                            <p>Are Prints Available: {client.are_prints_available}</p>
                                                            <p>Is it an environmental
                                                                firm: {client.is_it_an_environmental_firm}</p>
                                                            <p>Is the State Involved: {client.is_the_state_involved}</p>
                                                            <p>State ID: {client.state_id}</p>
                                                            <p>Additional Comments: {client.additional_comments}</p>
                                                            <Link className={'btn btn-info'}
                                                                  to={`/clients/update/${client.id}/`}>Update
                                                                Client
                                                            </Link>
                                                        </div>
                                                    </Collapse>
                                                </div>
                                            )
                                            :
                                            ("Client Done")
                                        }


                                        <br/>


                                        {
                                            presite === "None"
                                                ?
                                                (
                                                    <Link className={'btn btn-warning'}
                                                          to={`/clients/${client.id}/addpresite`}>
                                                        Add Pre-Site
                                                    </Link>
                                                )
                                                :
                                                (
                                                    <Button
                                                        onClick={() => setPreSiteOpen(!preSiteOpen)}
                                                        aria-controls="example-collapse-text"
                                                        aria-expanded={preSiteOpen}
                                                        className={'btn btn-primary'}
                                                    >
                                                        Pre-Site Details
                                                    </Button>
                                                )
                                        }

                                        <br/>
                                        <Collapse in={preSiteOpen} className={'collapse-area'}>
                                            <div id="example-collapse-text">
                                                <h3>Pre-site Details:</h3>
                                                <p>Lock Box or Entry Code: {presite.lock_box_or_entry_code}</p>
                                                <p>Safety Equipment Needed:{presite.safety_equipment_needed}</p>
                                                <p>General Notes: {presite.general_notes}</p>
                                                <p>Is Property Vacant: {presite.is_property_vacant}</p>
                                                <p>Site Hours: {presite.site_hours}</p>
                                                <p>Onsite Contact: {presite.onsite_contact}</p>
                                                <p>Onsite Contact phone: {presite.onsite_contact_phone}</p>
                                                <p>Onsite: Contact Email: {presite.onsite_contact_email}</p>
                                                {
                                                    presite.prints ? (
                                                        <a href={`https://homesafetysolutions.pythonanywhere.com${presite.prints}`}><img
                                                            className={'processImages'}
                                                            src={`https://homesafetysolutions.pythonanywhere.com${presite.prints}`}
                                                            alt={'prints'}/></a>) : ("No Prints")
                                                }
                                                <br/> <br/>
                                                {
                                                    presite.prints2 ? (
                                                        <a href={`https://homesafetysolutions.pythonanywhere.com${presite.prints2}`}><img
                                                            className={'processImages'}
                                                            src={`https://homesafetysolutions.pythonanywhere.com${presite.prints2}`}
                                                            alt={'prints 2'}/></a>) : ("No Prints 2")
                                                }
                                                <br/> <br/>
                                                {
                                                    presite.prints3 ? (
                                                        <a href={`https://homesafetysolutions.pythonanywhere.com${presite.prints3}`}><img
                                                            className={'processImages'}
                                                            src={`https://homesafetysolutions.pythonanywhere.com${presite.prints3}`}
                                                            alt={'prints 3'}/></a>) : ("No Prints 3")
                                                }
                                                <br/> <br/>
                                                {
                                                    presite.prints4 ? (
                                                        <a href={`https://homesafetysolutions.pythonanywhere.com${presite.prints4}`}><img
                                                            className={'processImages'}
                                                            src={`https://homesafetysolutions.pythonanywhere.com${presite.prints4}`}
                                                            alt={"prints 4"}/></a>) : ("No Prints 4")
                                                }
                                                <br/> <br/>
                                                {
                                                    presite.prints5 ? (
                                                        <a href={`https://homesafetysolutions.pythonanywhere.com${presite.prints5}`}><img
                                                            className={'processImages'}
                                                            src={`https://homesafetysolutions.pythonanywhere.com${presite.prints5}`}
                                                            alt={'prints 5'}/></a>) : ("No Prints 5")
                                                }
                                                <br/>
                                                <Link
                                                    className={'btn btn-info'}
                                                    to={`/presite/update/${id}/`}
                                                >
                                                    Update PreSite
                                                </Link>

                                            </div>
                                        </Collapse>
                                        <br/>

                                        {
                                            presite !== "None"
                                            ?
                                                (
                                                    <div>
                                                        {
                                                            onSite === "None"
                                                                ?
                                                                (
                                                                    <Link
                                                                        className={'btn btn-warning'}
                                                                        to={`/clients/${client.id}/addonsite/`}
                                                                    >
                                                                        Add OnSite
                                                                    </Link>
                                                                )
                                                                :
                                                                (
                                                                    <Button
                                                                        onClick={() => setOnSiteOpen(!onSiteOpen)}
                                                                        aria-controls="example-collapse-text"
                                                                        aria-expanded={onSiteOpen}
                                                                        className={'btn btn-primary'}
                                                                    >
                                                                        OnSite Details
                                                                    </Button>
                                                                )
                                                        }
                                                    </div>
                                                )
                                                :
                                                (
                                                    'Add Pre-Site to Add On-Site'
                                                )
                                        }
                                        <br/>
                                        <br/>
                                        <Collapse in={onSiteOpen} className={'collapse-area'}>
                                            <div id="example-collapse-text">
                                                <h3>Onsite Details:</h3>
                                                <p>Height to ceiling in feet: {onSite.height_to_ceiling_in_feet}</p>
                                                <p>Roof Access: {onSite.roof_access}</p>
                                                <p>Type of Roof: {onSite.type_of_roof}</p>
                                                <p>Drop Ceiling: {onSite.drop_ceiling}</p>
                                                <p>Type of Ceiling: {onSite.type_of_ceiling}</p>
                                                <p>Electrical: {onSite.electrical}</p>
                                                <p>Soil Type: {onSite.soil_type}</p>
                                                <p>Soil Removal: {onSite.soil_removal}</p>
                                                <p>Water on Site: {onSite.water_on_site}</p>
                                                <p>Lights on Site: {onSite.lights_on_site}</p>
                                                <p>Electricity on Site: {onSite.electricity_on_site}</p>
                                                <p>Bathrooms on Site: {onSite.bath_room_on_site}</p>
                                                <p>Permit Required: {onSite.permit_required}</p>
                                                <p>After Completion: {onSite.after_completion}</p>
                                                <p>Type of Permit: {onSite.type_of_permit}</p>
                                                <p>Who Completed OnSite: {onSite.who_completed_onsite}</p>
                                                <p>OnSite Notes: {onSite.onsite_notes}</p>

                                                {
                                                    onSite.photo1 ? (
                                                        <a href={`https://homesafetysolutions.pythonanywhere.com${onSite.photo1}`}><img
                                                            className={'processImages'}
                                                            src={`https://homesafetysolutions.pythonanywhere.com${onSite.photo1}`}
                                                            alt={'photo'}/></a>) : ("No photo 1")
                                                }
                                                <br/> <br/>
                                                {
                                                    onSite.photo2 ? (
                                                        <a href={`https://homesafetysolutions.pythonanywhere.com${onSite.photo2}`}><img
                                                            className={'processImages'}
                                                            src={`https://homesafetysolutions.pythonanywhere.com${onSite.photo2}`}
                                                            alt={'photo 2'}/></a>) : ("No photo 2")
                                                }
                                                <br/> <br/>
                                                {
                                                    onSite.photo3 ? (
                                                        <a href={`https://homesafetysolutions.pythonanywhere.com${onSite.photo3}`}><img
                                                            className={'processImages'}
                                                            src={`https://homesafetysolutions.pythonanywhere.com${onSite.photo3}`}
                                                            alt={'photo 3'}/></a>) : ("No photo 3")
                                                }
                                                <br/> <br/>
                                                {
                                                    onSite.photo4 ? (
                                                        <a href={`https://homesafetysolutions.pythonanywhere.com${onSite.photo4}`}><img
                                                            className={'processImages'}
                                                            src={`https://homesafetysolutions.pythonanywhere.com${onSite.photo4}`}
                                                            alt={"photo 4"}/></a>) : ("No photo 4")
                                                }
                                                <br/> <br/>
                                                {
                                                    onSite.photo5 ? (
                                                        <a href={`https://homesafetysolutions.pythonanywhere.com${onSite.photo5}`}><img
                                                            className={'processImages'}
                                                            src={`https://homesafetysolutions.pythonanywhere.com${onSite.photo5}`}
                                                            alt={'photo 5'}/></a>) : ("No photo 5")
                                                }
                                                <br/> <br/>
                                                {
                                                    onSite.photo6 ? (
                                                        <a href={`https://homesafetysolutions.pythonanywhere.com${onSite.photo6}`}><img
                                                            className={'processImages'}
                                                            src={`https://homesafetysolutions.pythonanywhere.com${onSite.photo6}`}
                                                            alt={'photo 6'}/></a>) : ("No photo 6")
                                                }
                                                <br/> <br/>
                                                {
                                                    onSite.photo7 ? (
                                                        <a href={`https://homesafetysolutions.pythonanywhere.com${onSite.photo7}`}><img
                                                            className={'processImages'}
                                                            src={`https://homesafetysolutions.pythonanywhere.com${onSite.photo7}`}
                                                            alt={'photo 7'}/></a>) : ("No photo 7")
                                                }
                                                <br/> <br/>
                                                {
                                                    onSite.photo8 ? (
                                                        <a href={`https://homesafetysolutions.pythonanywhere.com${onSite.photo8}`}><img
                                                            className={'processImages'}
                                                            src={`https://homesafetysolutions.pythonanywhere.com${onSite.photo8}`}
                                                            alt={'photo 8'}/></a>) : ("No photo 8")
                                                }
                                                <br/> <br/>
                                                {
                                                    onSite.photo9 ? (
                                                        <a href={`https://homesafetysolutions.pythonanywhere.com${onSite.photo9}`}><img
                                                            className={'processImages'}
                                                            src={`https://homesafetysolutions.pythonanywhere.com${onSite.photo9}`}
                                                            alt={'photo 9'}/></a>) : ("No photo 9")
                                                }
                                                <br/> <br/>
                                                {
                                                    onSite.photo10 ? (
                                                        <a href={`https://homesafetysolutions.pythonanywhere.com${onSite.photo10}`}><img
                                                            className={'processImages'}
                                                            src={`https://homesafetysolutions.pythonanywhere.com${onSite.photo10}`}
                                                            alt={'photo 10'}/></a>) : ("No photo 10")
                                                }
                                                <br/>
                                                <Link className={'btn btn-info'} to={`/onsite/update/${client.id}/`}>Update
                                                    OnSite</Link>
                                            </div>
                                        </Collapse>
                                        {
                                            workOrder !=="None"
                                            ?
                                                (
                                                    <div>
                                                        {
                                                            checklist === "None"
                                                                ?
                                                                (
                                                                    <Link
                                                                        className={'btn btn-warning'}
                                                                        to={`/clients/${client.id}/addchecklist/`}
                                                                    >
                                                                        Add Check List
                                                                    </Link>
                                                                )
                                                                :
                                                                (
                                                                    <Button
                                                                        onClick={() => setChecklistOpen(!checklistOpen)}
                                                                        aria-controls="example-collapse-text"
                                                                        aria-expanded={checklistOpen}
                                                                        className={'btn btn-primary'}
                                                                    >
                                                                        CheckList Details
                                                                    </Button>
                                                                )
                                                        }
                                                    </div>
                                                )
                                                :
                                                ('Add Work Order to Add Checklist')
                                        }
                                        <br/>
                                        <br/>

                                        {
                                            workOrder !== "None"
                                                ?
                                                (
                                                    <div>
                                                        {userInfo.group !== 'Tech'
                                                            ?
                                                            (
                                                                <div>
                                                                    {
                                                                        priority === "None"
                                                                            ?
                                                                            (
                                                                                <Link
                                                                                    className={'btn btn-warning'}
                                                                                    to={`/clients/${client.id}/addpriority/`}
                                                                                >
                                                                                    Add Priority
                                                                                </Link>
                                                                            )
                                                                            :
                                                                            (
                                                                                <Button
                                                                                    onClick={() => setPriorityOpen(!priorityOpen)}
                                                                                    aria-controls="example-collapse-text"
                                                                                    aria-expanded={priorityOpen}
                                                                                    className={'btn btn-primary'}
                                                                                >
                                                                                    Priority Details
                                                                                </Button>
                                                                            )
                                                                    }
                                                                    <br/>
                                                                    <Collapse in={priorityOpen} className={'collapse-area'}>
                                                                        <div id="example-collapse-text">
                                                                            <h3>Priority Details:</h3>
                                                                            <p>Priority Date: {priority.priority_date}</p>
                                                                            <p>Priority: {priority.priority}</p>
                                                                            <p>Finished: {priority.finished}</p>
                                                                            <br/>
                                                                            <Link className={'btn btn-info'}
                                                                                  to={`/priority_reports/update/${id}/`}>Update Priority</Link>
                                                                        </div>
                                                                    </Collapse>
                                                                </div>
                                                            )
                                                            :
                                                            (
                                                                'Priority Done'
                                                            )
                                                        }
                                                    </div>
                                                )
                                                :
                                                (
                                                    'Add Work Order to Add Priority'
                                                )
                                        }

                                        <Collapse in={checklistOpen} className={'collapse-area'}>
                                            <div id="example-collapse-text">
                                                <h3>Checklist Details:</h3>
                                                <a href={checklist.forms_link} target={'_blank'} rel="noreferrer">Forms
                                                    link: {checklist.forms_link}</a>
                                                <p>Is premeditation done: {checklist.is_premeditation_done}</p>
                                                <p>Is active mitigation done: {checklist.is_active_mitigation_done}</p>
                                                <p>Is post mitigation done: {checklist.is_post_mitigation_done}</p>
                                                <p>Are gauges on: {checklist.are_gauges_on}</p>
                                                <p>Is system labeled: {checklist.is_system_labeled}</p>
                                                <p>Is_om and m done: {checklist.is_om_and_m_done}</p>
                                                <p>Is electrical done: {checklist.is_electrical_done}</p>
                                                <p>Is fan on: {checklist.is_fan_on}</p>
                                                <p>Ready to invoice: {checklist.ready_to_invoice}</p>
                                                <p>None of the above apply: {checklist.none_of_the_above_apply}</p>
                                                <p>Job is fully completed: {checklist.job_is_fully_completed}</p>
                                                <br/>
                                                <Link className={'btn btn-info'} to={`/check_list/update/${id}/`}>Update
                                                    Check List</Link>
                                            </div>
                                        </Collapse>
                                        <br/>
                                    </Col>
                                    <br/>

                                    <Col>
                                        {
                                            onSite !== 'None'
                                            ?
                                                (
                                                    <div>
                                                        {userInfo.group !== 'Tech'
                                                            ?
                                                            (
                                                                <div>
                                                                    {
                                                                        proposal === "None"
                                                                            ?
                                                                            (
                                                                                <Link
                                                                                    className={'btn btn-warning'}
                                                                                    to={`/clients/${client.id}/addproposal/`}
                                                                                >
                                                                                    Add Proposal
                                                                                </Link>
                                                                            )
                                                                            :
                                                                            (
                                                                                <Button
                                                                                    onClick={() => setProposalOpen(!proposalOpen)}
                                                                                    aria-controls="example-collapse-text"
                                                                                    aria-expanded={proposalOpen}
                                                                                    className={'btn btn-primary'}
                                                                                >
                                                                                    Proposal Details
                                                                                </Button>
                                                                            )
                                                                    }
                                                                    <br/>
                                                                    <Collapse in={proposalOpen} className={'collapse-area'}>
                                                                        <div id="example-collapse-text">
                                                                            <h3>Proposal Details:</h3>
                                                                            <p>Proposal Approved
                                                                                Date: {proposal.proposal_approved_date}</p>
                                                                            <p>Proposal Amount: {proposal.proposal_amount}</p>
                                                                            <p>Priority: {proposal.priority}</p>

                                                                            <p>Who to bill name: {proposal.who_to_bill_name}</p>
                                                                            <p>Who to bill phone: {proposal.who_to_bill_phone}</p>
                                                                            <p>Who to bill email: {proposal.who_to_bill_email}</p>

                                                                            {
                                                                                proposal.pic1 ? (
                                                                                    <a href={`https://homesafetysolutions.pythonanywhere.com${proposal.pic1}`}><img
                                                                                        className={'processImages'}
                                                                                        src={`https://homesafetysolutions.pythonanywhere.com${proposal.pic1}`}
                                                                                        alt={'prints'}/></a>) : ("No Picture")
                                                                            }
                                                                            <br/> <br/>
                                                                            {
                                                                                proposal.pic2 ? (
                                                                                    <a href={`https://homesafetysolutions.pythonanywhere.com${proposal.pic2}`}><img
                                                                                        className={'processImages'}
                                                                                        src={`https://homesafetysolutions.pythonanywhere.com${proposal.pic2}`}
                                                                                        alt={'prints 2'}/></a>) : ("No Picture 2")
                                                                            }
                                                                            <br/> <br/>
                                                                            {
                                                                                proposal.pic3 ? (
                                                                                    <a href={`https://homesafetysolutions.pythonanywhere.com${proposal.pic3}`}><img
                                                                                        className={'processImages'}
                                                                                        src={`https://homesafetysolutions.pythonanywhere.com${proposal.pic3}`}
                                                                                        alt={'prints 3'}/></a>) : ("No Picture 3")
                                                                            }
                                                                            <br/> <br/>
                                                                            {
                                                                                proposal.pic4 ? (
                                                                                    <a href={`https://homesafetysolutions.pythonanywhere.com${proposal.pic4}`}><img
                                                                                        className={'processImages'}
                                                                                        src={`https://homesafetysolutions.pythonanywhere.com${proposal.pic4}`}
                                                                                        alt={"prints 4"}/></a>) : ("No Picture 4")
                                                                            }
                                                                            <br/> <br/>
                                                                            {
                                                                                proposal.pic5 ? (
                                                                                    <a href={`https://homesafetysolutions.pythonanywhere.com${proposal.pic5}`}><img
                                                                                        className={'processImages'}
                                                                                        src={`https://homesafetysolutions.pythonanywhere.com${proposal.pic5}`}
                                                                                        alt={'prints 5'}/></a>) : ("No Picture 5")
                                                                            }
                                                                            <br/> <br/>
                                                                            {
                                                                                proposal.pic6 ? (
                                                                                    <a href={`https://homesafetysolutions.pythonanywhere.com${proposal.pic6}`}><img
                                                                                        className={'processImages'}
                                                                                        src={`https://homesafetysolutions.pythonanywhere.com${proposal.pic6}`}
                                                                                        alt={'prints 5'}/></a>) : ("No Picture 5")
                                                                            }
                                                                            <br/> <br/>
                                                                            {
                                                                                proposal.sign_doc_pic ? (
                                                                                    <a href={`https://homesafetysolutions.pythonanywhere.com${proposal.sign_doc_pic}`}><img
                                                                                        className={'processImages'}
                                                                                        src={`https://homesafetysolutions.pythonanywhere.com${proposal.sign_doc_pic}`}
                                                                                        alt={'prints 5'}/></a>) : ("No Signed Document Picture")
                                                                            }
                                                                            <br/>
                                                                            <br/>
                                                                            <Link className={'btn btn-info'}
                                                                                  to={`/proposal/update/${id}/`}>Update Proposal</Link>
                                                                        </div>
                                                                    </Collapse>
                                                                </div>
                                                            )
                                                            :
                                                            (
                                                                'Proposal Done'
                                                            )
                                                        }
                                                    </div>
                                                )
                                                :
                                                (
                                                    "Add On Site to Add Proposal"
                                                )
                                        }

                                        <br/><br/>

                                        {
                                            proposal !== "None"
                                            ?
                                                (
                                                    <div>
                                                        {userInfo.group !== 'Tech'
                                                            ?
                                                            (
                                                                <div>
                                                                    {
                                                                        invoice === "None"
                                                                            ?
                                                                            (
                                                                                <Link
                                                                                    className={'btn btn-warning'}
                                                                                    to={`/clients/${client.id}/addinvoice/`}
                                                                                >
                                                                                    Add Invoice
                                                                                </Link>
                                                                            )
                                                                            :
                                                                            (
                                                                                <Button
                                                                                    onClick={() => setInvoiceOpen(!invoiceOpen)}
                                                                                    aria-controls="example-collapse-text"
                                                                                    aria-expanded={invoiceOpen}
                                                                                    className={'btn btn-primary'}
                                                                                >
                                                                                    Invoice Details
                                                                                </Button>
                                                                            )
                                                                    }
                                                                    <br/>
                                                                    <Collapse in={invoiceOpen} className={'collapse-area'}>
                                                                        <div id="example-collapse-text">
                                                                            <h3>Invoice Details:</h3>
                                                                            <p>Bill amount: {invoice.bill_amount}</p>
                                                                            <p>Is Down payment made: {invoice.is_down_payment_made}</p>
                                                                            <p>Down-payment amount: {invoice.down_payment_amount}</p>
                                                                            <p>Current balance due: {invoice.current_balance_due}</p>
                                                                            <p>Payment made in full: {invoice.payment_made_in_full}</p>
                                                                            <p>Priority: {invoice.priority}</p>
                                                                            <p>Payment plan: {invoice.payment_plan}</p>
                                                                            <p>P.O.: {invoice.po}</p>
                                                                            <p>Work order number: {invoice.work_order_number}</p>
                                                                            <p>Project I.D.: {invoice.project_id}</p>
                                                                            <p>Payment notes: {invoice.payment_notes}</p>
                                                                            <br/>
                                                                            <Link className={'btn btn-info'}
                                                                                  to={`/invoice/update/${id}/`}>Update Invoice</Link>
                                                                        </div>
                                                                    </Collapse>
                                                                </div>
                                                            )
                                                            :
                                                            (
                                                                'Invoice Done'
                                                            )
                                                        }
                                                    </div>
                                                )
                                                :
                                                (
                                                    'Add Proposal to Add Invoice'
                                                )
                                        }
                                        <br/><br/>
                                        {
                                            invoice !== 'None'
                                            ?
                                                (
                                                    <div>
                                                        {
                                                            workOrder === "None"
                                                                ?
                                                                (
                                                                    <Link
                                                                        className={'btn btn-warning'}
                                                                        to={`/clients/${client.id}/addworkorder/`}
                                                                    >
                                                                        Add Work-Order
                                                                    </Link>
                                                                )
                                                                :
                                                                (
                                                                    <Button
                                                                        onClick={() => setWorkOrderOpen(!workOrderOpen)}
                                                                        aria-controls="example-collapse-text"
                                                                        aria-expanded={workOrderOpen}
                                                                        className={'btn btn-primary'}
                                                                    >
                                                                        WorkOrder Details
                                                                    </Button>
                                                                )
                                                        }
                                                    </div>
                                                )
                                                :
                                                (
                                                    "Add Invoice to Add Work Order"
                                                )
                                        }

                                        <br/>
                                        <Collapse in={workOrderOpen} className={'collapse-area'}>
                                            <div id="example-collapse-text">
                                                <h3>Work Order Details:</h3>
                                                <p>System Installed: {workOrder.system_installed}</p>
                                                <p>Job Completed: {workOrder.job_completed}</p>
                                                <p>Done: {workOrder.done}</p>
                                                <p>Cracked Ceiling: {workOrder.cracked_ceiling}</p>
                                                {
                                                    workOrder.prevailing_wage === "Yes"
                                                        ?
                                                        (<p style={{background: 'red', color: "white"}}>Prevailing
                                                            wage: {workOrder.prevailing_wage}</p>)
                                                        :
                                                        (<p>Prevailing wage: {workOrder.prevailing_wage}</p>)
                                                }
                                                <p>Estimated job length: {workOrder.estimated_job_length}</p>
                                                <p>Scheduling reviewed: {workOrder.scheduling_reviewed}</p>
                                                <p>Are we hiring a roofing
                                                    company: {workOrder.are_we_hiring_a_roofing_company}</p>
                                                <p>Roofing company contact: {workOrder.roofing_company_contact}</p>
                                                <p>Are we hiring an
                                                    electrician: {workOrder.are_we_hiring_an_electrician}</p>
                                                <p>Number of fans needed: {workOrder.number_of_fans_needed}</p>
                                                <p>Type of fan: {workOrder.type_of_fan}</p>
                                                <p>Work to be done: {workOrder.work_to_be_done}</p>
                                                <p>Notes from site: {workOrder.notes_from_site}</p>

                                                {
                                                    workOrder.design_picture_1 ? (
                                                        <a href={`https://homesafetysolutions.pythonanywhere.com${workOrder.design_picture_1}`}><img
                                                            className={'processImages'}
                                                            src={`https://homesafetysolutions.pythonanywhere.com${workOrder.design_picture_1}`}
                                                            alt={'design picture 1'}/></a>) : ("No Design Picture")
                                                }
                                                <br/> <br/>
                                                {
                                                    workOrder.design_picture_2 ? (
                                                        <a href={`https://homesafetysolutions.pythonanywhere.com${workOrder.design_picture_2}`}><img
                                                            className={'processImages'}
                                                            src={`https://homesafetysolutions.pythonanywhere.com${workOrder.design_picture_2}`}
                                                            alt={'design picture 2'}/></a>) : ("No Design Picture")
                                                }
                                                <br/> <br/>
                                                {
                                                    workOrder.design_picture_3 ? (
                                                        <a href={`https://homesafetysolutions.pythonanywhere.com${workOrder.design_picture_3}`}><img
                                                            className={'processImages'}
                                                            src={`https://homesafetysolutions.pythonanywhere.com${workOrder.design_picture_3}`}
                                                            alt={'design picture 3'}/></a>) : ("No Design Picture")
                                                }
                                                <br/> <br/>
                                                {
                                                    workOrder.design_picture_4 ? (
                                                        <a href={`https://homesafetysolutions.pythonanywhere.com${workOrder.design_picture_4}`}><img
                                                            className={'processImages'}
                                                            src={`https://homesafetysolutions.pythonanywhere.com${workOrder.design_picture_4}`}
                                                            alt={'design picture 4'}/></a>) : ("No Design Picture")
                                                }
                                                <br/> <br/>
                                                {
                                                    workOrder.design_picture_5 ? (
                                                        <a href={`https://homesafetysolutions.pythonanywhere.com${workOrder.design_picture_5}`}><img
                                                            className={'processImages'}
                                                            src={`https://homesafetysolutions.pythonanywhere.com${workOrder.design_picture_5}`}
                                                            alt={'design picture 5'}/></a>) : ("No Design Picture")
                                                }
                                                <br/>
                                                <Link className={'btn btn-info'} to={`/workorder/update/${id}/`}>Update
                                                    Work Order</Link>
                                            </div>
                                        </Collapse>
                                        <br/>
                                        {
                                            workOrder !== 'None'
                                            ?
                                                (
                                                    <div>
                                                        {
                                                            workHours === 'None'
                                                                ?
                                                                (
                                                                    <Link
                                                                        className={'btn btn-warning'}
                                                                        to={`/clients/${client.id}/addhours/`}
                                                                    >
                                                                        Add Hours
                                                                    </Link>
                                                                )
                                                                :
                                                                (
                                                                    <div>
                                                                        <Link
                                                                            className={'btn btn-warning'}
                                                                            to={`/clients/${client.id}/addhours/`}
                                                                        >
                                                                            Add Hours
                                                                        </Link>
                                                                        <br/> <br/>
                                                                        <Button
                                                                            onClick={() => setHoursWorkedOpen(!hoursWorkedOpen)}
                                                                            aria-controls="example-collapse-text"
                                                                            aria-expanded={hoursWorkedOpen}
                                                                            className={'btn btn-primary'}
                                                                        >
                                                                            Hours Details
                                                                        </Button>
                                                                    </div>

                                                                )
                                                        }
                                                    </div>
                                                )
                                                :
                                                (
                                                    "Add Work Orders to Add Hours"
                                                )
                                        }
                                        <br/>
                                        <Collapse in={hoursWorkedOpen} className={'collapse-area'}>
                                            <div id="example-collapse-text">
                                                <h3>Hours Worked:</h3>
                                                {workHours.map(hour =>
                                                    <div key={hour.id}>
                                                        <p>Hours
                                                            Created: {Moment(hour.created).format("MM/DD/YYYY")}</p>
                                                        <Row>
                                                            <Col>
                                                                <Link className={'btn btn-info'}
                                                                      to={`/workhour/${hour.id}/`}>
                                                                    Detail Hours
                                                                </Link>
                                                            </Col>
                                                            <Col>
                                                                <Link className={'btn btn-warning'}
                                                                      to={`/workhour/update/${hour.id}/`}>
                                                                    Update Hours
                                                                </Link>
                                                            </Col>
                                                        </Row>
                                                        <br />
                                                    </div>
                                                )}
                                                <br/>
                                            </div>
                                        </Collapse>

                                    </Col>
                                </Row>
                            </div>
                        )
                }
            </div>

        </div>
    );
};

export default SearchResults;


// import React, {useState, useEffect} from "react";
// import axios from "axios";
// import {Link, useParams, useResolvedPath} from "react-router-dom";
// import {useSelector} from "react-redux";
// import Button from "react-bootstrap/Button";
// import {Col, Collapse, Row} from "react-bootstrap";
// import Moment from "moment";
//
//
// const SearchResults = () => {
//
//     const [client, setClient] = useState([""])
//     const [presite, setPresite] = useState([""])
//     const [onSite, setOnSite] = useState([""])
//     const [proposal, setProposal] = useState([""])
//     const [invoice, setInvoice] = useState([""])
//     const [workOrder, setWorkOrder] = useState([""])
//     const [checklist, setCheckList] = useState([""])
//     const [workHours, setWorkHours] = useState([''])
//
//     const [loading, setLoading] = useState(false)
//
//     const [clientOpen, setClientOpen] = useState(false);
//     const [preSiteOpen, setPreSiteOpen] = useState(false);
//     const [onSiteOpen, setOnSiteOpen] = useState(false);
//     const [proposalOpen, setProposalOpen] = useState(false);
//     const [invoiceOpen, setInvoiceOpen] = useState(false);
//     const [workOrderOpen, setWorkOrderOpen] = useState(false);
//     const [checklistOpen, setChecklistOpen] = useState(false);
//     const [hoursWorkedOpen, setHoursWorkedOpen] = useState(false);
//
//     const {id} = useParams()
//
//     const userLogin = useSelector(state => state.userLogin)
//     const {userInfo} = userLogin
//
//
//     const getContactInfo = async () => {
//         setLoading(true)
//
//         // const {data} = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/clients/${id}/`, {
//         const {data} = await axios.get(`http://127.0.0.1:8000/api/clients/${id}/`, {
//             headers: {
//                 'Content-type': 'application/json',
//                 Authorization: `Bearer ${userInfo.token}`
//             }
//         })
//         setClient(data)
//         setLoading(false)
//     }
//
//     const getSinglePresite = async () => {
//         setLoading(true)
//         // const {data} = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/presite/${id}/`, {
//         const {data} = await axios.get(`http://127.0.0.1:8000/api/presite/${id}/`, {
//             headers: {
//                 'Content-type': 'application/json',
//                 Authorization: `Bearer ${userInfo.token}`
//             }
//         })
//         setPresite(data)
//         setLoading(false)
//     }
//
//     const getSingleOnSite = async () => {
//         setLoading(true)
//         // const {data} = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/onsite/${id}/`, {
//         const {data} = await axios.get(`http://127.0.0.1:8000/api/onsite/${id}/`, {
//             headers: {
//                 'Content-type': 'application/json',
//                 Authorization: `Bearer ${userInfo.token}`
//             }
//         })
//         setOnSite(data)
//         setLoading(false)
//     }
//
//     const getSingleProposal = async () => {
//         setLoading(true)
//         // const {data} = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/proposals/${id}/`, {
//         const {data} = await axios.get(`http://127.0.0.1:8000/api/proposals/${id}/`, {
//             headers: {
//                 'Content-type': 'application/json',
//                 Authorization: `Bearer ${userInfo.token}`
//             }
//         })
//         setProposal(data)
//         setLoading(false)
//     }
//
//     const getSingleInvoice = async () => {
//         setLoading(true)
//         // const {data} = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/invoices/${id}/`, {
//         const {data} = await axios.get(`http://127.0.0.1:8000/api/invoices/${id}/`, {
//             headers: {
//                 'Content-type': 'application/json',
//                 Authorization: `Bearer ${userInfo.token}`
//             }
//         })
//         setInvoice(data)
//         setLoading(false)
//     }
//
//     const getSingleWorkOrder = async () => {
//         setLoading(true)
//         // const {data} = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/workorders/${id}/`, {
//         const {data} = await axios.get(`http://127.0.0.1:8000/api/workorders/${id}/`, {
//             headers: {
//                 'Content-type': 'application/json',
//                 Authorization: `Bearer ${userInfo.token}`
//             }
//         })
//         setWorkOrder(data)
//         setLoading(false)
//     }
//
//     const getSingleCheckList = async () => {
//         setLoading(true)
//         // const {data} = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/check_list/${id}/`, {
//         const {data} = await axios.get(`http://127.0.0.1:8000/api/check_list/${id}/`, {
//             headers: {
//                 'Content-type': 'application/json',
//                 Authorization: `Bearer ${userInfo.token}`
//             }
//         })
//         setCheckList(data)
//         setLoading(false)
//     }
//
//     const getWorkHours = async () => {
//         setLoading(true)
//         // const {data} = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/clienthours/${id}/`, {
//         const {data} = await axios.get(`http://127.0.0.1:8000/api/clienthours/${id}/`, {
//             headers: {
//                 'Content-type': 'application/json',
//                 Authorization: `Bearer ${userInfo.token}`
//             }
//         })
//         setWorkHours(data)
//         setLoading(false)
//     }
//
//     useEffect(() => {
//         getContactInfo();
//         getSinglePresite();
//         getSingleOnSite();
//         getSingleProposal();
//         getSingleInvoice();
//         getSingleWorkOrder();
//         getSingleCheckList();
//         getWorkHours();
//     }, [])
//
//     return (
//         <div>
//             <h1>Search Results For: {client.work_site_address}</h1>
//             <br/>
//             <div>
//                 {
//                     loading
//                         ?
//                         (
//                             <h4>
//                                 Loading...
//                             </h4>
//                         )
//                         :
//                         (
//                             <div>
//                                 <Row>
//                                     <Col>
//                                         {userInfo.group !== 'Tech'
//                                             ?
//                                             (
//                                                 <div>
//                                                     <Button
//                                                         onClick={() => setClientOpen(!clientOpen)}
//                                                         aria-controls="example-collapse-text"
//                                                         aria-expanded={clientOpen}
//                                                         className={'btn btn-primary'}
//                                                     >
//                                                         Client Details
//                                                     </Button>
//
//                                                     <br/>
//
//                                                     <Collapse in={clientOpen} className={'collapse-area'}>
//                                                         <div id="example-collapse-text">
//                                                             <h3>Client Details:</h3>
//                                                             <p>Work Site Address: {client.work_site_address}</p>
//                                                             <p>Details For Address: {client.details_for_address}</p>
//                                                             <p>Project ID: {client.project_ID}</p>
//                                                             <p>Referral Name: {client.referral_name}</p>
//                                                             <p>Phone: {client.phone}</p>
//                                                             <p>Email: {client.email}</p>
//                                                             <p>Service Order: {client.service_order}</p>
//                                                             <p>Client Name: {client.client_name}</p>
//                                                             <p>Client Phone: {client.client_phone}</p>
//                                                             <p>Organization's Name: {client.organization_name}</p>
//                                                             {
//                                                                 client.new_client === "Yes"
//                                                                     ?
//                                                                     (<p style={{
//                                                                         background: 'red',
//                                                                         color: 'white'
//                                                                     }}>New Client: {client.new_client}</p>)
//                                                                     :
//                                                                     (<p>New Client: {client.new_client}</p>)
//                                                             }
//                                                             <p>From Where: {client.from_where}</p>
//                                                             <p>From Where
//                                                                 Description: {client.from_where_description}</p>
//                                                             <p>Requested Service: {client.requested_service}</p>
//                                                             <p>Are Prints Available: {client.are_prints_available}</p>
//                                                             <p>Is it an environmental
//                                                                 firm: {client.is_it_an_environmental_firm}</p>
//                                                             <p>Is the State Involved: {client.is_the_state_involved}</p>
//                                                             <p>State ID: {client.state_id}</p>
//                                                             <p>Additional Comments: {client.additional_comments}</p>
//                                                             <Link className={'btn btn-info'}
//                                                                   to={`/clients/update/${client.id}/`}>Update
//                                                                 Client</Link>
//                                                         </div>
//                                                     </Collapse>
//                                                 </div>
//                                             )
//                                             :
//                                             ("Client Done")
//                                         }
//
//
//                                         <br/>
//
//                                         <Button
//                                             onClick={() => setPreSiteOpen(!preSiteOpen)}
//                                             aria-controls="example-collapse-text"
//                                             aria-expanded={preSiteOpen}
//                                             className={'btn btn-primary'}
//                                         >
//                                             Pre-Site Details
//                                         </Button>
//
//                                         <br/>
//                                         <Collapse in={preSiteOpen} className={'collapse-area'}>
//                                             <div id="example-collapse-text">
//                                                 <h3>Pre-site Details:</h3>
//                                                 <p>Lock Box or Entry Code: {presite.lock_box_or_entry_code}</p>
//                                                 <p>Safety Equipment Needed:{presite.safety_equipment_needed}</p>
//                                                 <p>General Notes: {presite.general_notes}</p>
//                                                 <p>Is Property Vacant: {presite.is_property_vacant}</p>
//                                                 <p>Site Hours: {presite.site_hours}</p>
//                                                 <p>Onsite Contact: {presite.onsite_contact}</p>
//                                                 <p>Onsite Contact phone: {presite.onsite_contact_phone}</p>
//                                                 <p>Onsite: Contact Email: {presite.onsite_contact_email}</p>
//                                                 {
//                                                     presite.prints ? (
//                                                         <a href={`https://homesafetysolutions.pythonanywhere.com${presite.prints}`}><img
//                                                             className={'processImages'}
//                                                             src={`https://homesafetysolutions.pythonanywhere.com${presite.prints}`}
//                                                             alt={'prints'}/></a>) : ("No Prints")
//                                                 }
//                                                 <br/> <br/>
//                                                 {
//                                                     presite.prints2 ? (
//                                                         <a href={`https://homesafetysolutions.pythonanywhere.com${presite.prints2}`}><img
//                                                             className={'processImages'}
//                                                             src={`https://homesafetysolutions.pythonanywhere.com${presite.prints2}`}
//                                                             alt={'prints 2'}/></a>) : ("No Prints 2")
//                                                 }
//                                                 <br/> <br/>
//                                                 {
//                                                     presite.prints3 ? (
//                                                         <a href={`https://homesafetysolutions.pythonanywhere.com${presite.prints3}`}><img
//                                                             className={'processImages'}
//                                                             src={`https://homesafetysolutions.pythonanywhere.com${presite.prints3}`}
//                                                             alt={'prints 3'}/></a>) : ("No Prints 3")
//                                                 }
//                                                 <br/> <br/>
//                                                 {
//                                                     presite.prints4 ? (
//                                                         <a href={`https://homesafetysolutions.pythonanywhere.com${presite.prints4}`}><img
//                                                             className={'processImages'}
//                                                             src={`https://homesafetysolutions.pythonanywhere.com${presite.prints4}`}
//                                                             alt={"prints 4"}/></a>) : ("No Prints 4")
//                                                 }
//                                                 <br/> <br/>
//                                                 {
//                                                     presite.prints5 ? (
//                                                         <a href={`https://homesafetysolutions.pythonanywhere.com${presite.prints5}`}><img
//                                                             className={'processImages'}
//                                                             src={`https://homesafetysolutions.pythonanywhere.com${presite.prints5}`}
//                                                             alt={'prints 5'}/></a>) : ("No Prints 5")
//                                                 }
//                                                 <br/>
//                                                 <Link
//                                                     className={'btn btn-info'}
//                                                     to={`/presite/update/${id}/`}
//                                                 >
//                                                     Update PreSite
//                                                 </Link>
//
//                                             </div>
//                                         </Collapse>
//                                         <br/>
//
//                                         <Button
//                                             onClick={() => setOnSiteOpen(!onSiteOpen)}
//                                             aria-controls="example-collapse-text"
//                                             aria-expanded={onSiteOpen}
//                                             className={'btn btn-primary'}
//                                         >
//                                             OnSite Details
//                                         </Button>
//
//                                         <br/>
//                                         <Collapse in={onSiteOpen} className={'collapse-area'}>
//                                             <div id="example-collapse-text">
//                                                 <h3>Onsite Details:</h3>
//                                                 <p>Height to ceiling in feet: {onSite.height_to_ceiling_in_feet}</p>
//                                                 <p>Roof Access: {onSite.roof_access}</p>
//                                                 <p>Type of Roof: {onSite.type_of_roof}</p>
//                                                 <p>Drop Ceiling: {onSite.drop_ceiling}</p>
//                                                 <p>Type of Ceiling: {onSite.type_of_ceiling}</p>
//                                                 <p>Electrical: {onSite.electrical}</p>
//                                                 <p>Soil Type: {onSite.soil_type}</p>
//                                                 <p>Soil Removal: {onSite.soil_removal}</p>
//                                                 <p>Water on Site: {onSite.water_on_site}</p>
//                                                 <p>Lights on Site: {onSite.lights_on_site}</p>
//                                                 <p>Electricity on Site: {onSite.electricity_on_site}</p>
//                                                 <p>Bathrooms on Site: {onSite.bath_room_on_site}</p>
//                                                 <p>Permit Required: {onSite.permit_required}</p>
//                                                 <p>After Completion: {onSite.after_completion}</p>
//                                                 <p>Type of Permit: {onSite.type_of_permit}</p>
//                                                 <p>Who Completed OnSite: {onSite.who_completed_onsite}</p>
//                                                 <p>OnSite Notes: {onSite.onsite_notes}</p>
//
//                                                 {
//                                                     onSite.photo1 ? (
//                                                         <a href={`https://homesafetysolutions.pythonanywhere.com${onSite.photo1}`}><img
//                                                             className={'processImages'}
//                                                             src={`https://homesafetysolutions.pythonanywhere.com${onSite.photo1}`}
//                                                             alt={'photo'}/></a>) : ("No photo 1")
//                                                 }
//                                                 <br/> <br/>
//                                                 {
//                                                     onSite.photo2 ? (
//                                                         <a href={`https://homesafetysolutions.pythonanywhere.com${onSite.photo2}`}><img
//                                                             className={'processImages'}
//                                                             src={`https://homesafetysolutions.pythonanywhere.com${onSite.photo2}`}
//                                                             alt={'photo 2'}/></a>) : ("No photo 2")
//                                                 }
//                                                 <br/> <br/>
//                                                 {
//                                                     onSite.photo3 ? (
//                                                         <a href={`https://homesafetysolutions.pythonanywhere.com${onSite.photo3}`}><img
//                                                             className={'processImages'}
//                                                             src={`https://homesafetysolutions.pythonanywhere.com${onSite.photo3}`}
//                                                             alt={'photo 3'}/></a>) : ("No photo 3")
//                                                 }
//                                                 <br/> <br/>
//                                                 {
//                                                     onSite.photo4 ? (
//                                                         <a href={`https://homesafetysolutions.pythonanywhere.com${onSite.photo4}`}><img
//                                                             className={'processImages'}
//                                                             src={`https://homesafetysolutions.pythonanywhere.com${onSite.photo4}`}
//                                                             alt={"photo 4"}/></a>) : ("No photo 4")
//                                                 }
//                                                 <br/> <br/>
//                                                 {
//                                                     onSite.photo5 ? (
//                                                         <a href={`https://homesafetysolutions.pythonanywhere.com${onSite.photo5}`}><img
//                                                             className={'processImages'}
//                                                             src={`https://homesafetysolutions.pythonanywhere.com${onSite.photo5}`}
//                                                             alt={'photo 5'}/></a>) : ("No photo 5")
//                                                 }
//                                                 <br/> <br/>
//                                                 {
//                                                     onSite.photo6 ? (
//                                                         <a href={`https://homesafetysolutions.pythonanywhere.com${onSite.photo6}`}><img
//                                                             className={'processImages'}
//                                                             src={`https://homesafetysolutions.pythonanywhere.com${onSite.photo6}`}
//                                                             alt={'photo 6'}/></a>) : ("No photo 6")
//                                                 }
//                                                 <br/> <br/>
//                                                 {
//                                                     onSite.photo7 ? (
//                                                         <a href={`https://homesafetysolutions.pythonanywhere.com${onSite.photo7}`}><img
//                                                             className={'processImages'}
//                                                             src={`https://homesafetysolutions.pythonanywhere.com${onSite.photo7}`}
//                                                             alt={'photo 7'}/></a>) : ("No photo 7")
//                                                 }
//                                                 <br/> <br/>
//                                                 {
//                                                     onSite.photo8 ? (
//                                                         <a href={`https://homesafetysolutions.pythonanywhere.com${onSite.photo8}`}><img
//                                                             className={'processImages'}
//                                                             src={`https://homesafetysolutions.pythonanywhere.com${onSite.photo8}`}
//                                                             alt={'photo 8'}/></a>) : ("No photo 8")
//                                                 }
//                                                 <br/> <br/>
//                                                 {
//                                                     onSite.photo9 ? (
//                                                         <a href={`https://homesafetysolutions.pythonanywhere.com${onSite.photo9}`}><img
//                                                             className={'processImages'}
//                                                             src={`https://homesafetysolutions.pythonanywhere.com${onSite.photo9}`}
//                                                             alt={'photo 9'}/></a>) : ("No photo 9")
//                                                 }
//                                                 <br/> <br/>
//                                                 {
//                                                     onSite.photo10 ? (
//                                                         <a href={`https://homesafetysolutions.pythonanywhere.com${onSite.photo10}`}><img
//                                                             className={'processImages'}
//                                                             src={`https://homesafetysolutions.pythonanywhere.com${onSite.photo10}`}
//                                                             alt={'photo 10'}/></a>) : ("No photo 10")
//                                                 }
//                                                 <br/>
//                                                 <Link className={'btn btn-info'} to={`/onsite/update/${id}/`}>Update
//                                                     OnSite</Link>
//                                             </div>
//                                         </Collapse>
//                                         <br/>
//
//                                         <Button
//                                             onClick={() => setChecklistOpen(!checklistOpen)}
//                                             aria-controls="example-collapse-text"
//                                             aria-expanded={checklistOpen}
//                                             className={'btn btn-primary'}
//                                         >
//                                             CheckList Details
//                                         </Button>
//
//                                         <br/>
//                                         <Collapse in={checklistOpen} className={'collapse-area'}>
//                                             <div id="example-collapse-text">
//                                                 <h3>Checklist Details:</h3>
//                                                 <a href={checklist.forms_link} target={'_blank'} rel="noreferrer">Forms
//                                                     link: {checklist.forms_link}</a>
//                                                 <p>Is premeditation done: {checklist.is_premeditation_done}</p>
//                                                 <p>Is active mitigation done: {checklist.is_active_mitigation_done}</p>
//                                                 <p>Is post mitigation done: {checklist.is_post_mitigation_done}</p>
//                                                 <p>Are gauges on: {checklist.are_gauges_on}</p>
//                                                 <p>Is system labeled: {checklist.is_system_labeled}</p>
//                                                 <p>Is_om and m done: {checklist.is_om_and_m_done}</p>
//                                                 <p>Is electrical done: {checklist.is_electrical_done}</p>
//                                                 <p>Is fan on: {checklist.is_fan_on}</p>
//                                                 <p>Ready to invoice: {checklist.ready_to_invoice}</p>
//                                                 <p>None of the above apply: {checklist.none_of_the_above_apply}</p>
//                                                 <p>Job is fully completed: {checklist.job_is_fully_completed}</p>
//                                                 <br/>
//                                                 <Link className={'btn btn-info'} to={`/check_list/update/${id}/`}>Update
//                                                     Check List</Link>
//                                             </div>
//                                         </Collapse>
//                                         <br/>
//                                     </Col>
//                                     <br/>
//                                     <Col>
//
//                                         {userInfo.group !== 'Tech'
//                                             ?
//                                             (
//                                                 <div>
//                                                     <Button
//                                                         onClick={() => setProposalOpen(!proposalOpen)}
//                                                         aria-controls="example-collapse-text"
//                                                         aria-expanded={proposalOpen}
//                                                         className={'btn btn-primary'}
//                                                     >
//                                                         Proposal Details
//                                                     </Button>
//                                                     <br/>
//                                                     <Collapse in={proposalOpen} className={'collapse-area'}>
//                                                         <div id="example-collapse-text">
//                                                             <h3>Proposal Details:</h3>
//                                                             <p>Proposal Approved
//                                                                 Date: {proposal.proposal_approved_date}</p>
//                                                             <p>Proposal Amount: {proposal.proposal_amount}</p>
//                                                             <p>Priority: {proposal.priority}</p>
//
//                                                             <p>Who to bill name: {proposal.who_to_bill_name}</p>
//                                                             <p>Who to bill phone: {proposal.who_to_bill_phone}</p>
//                                                             <p>Who to bill email: {proposal.who_to_bill_email}</p>
//
//                                                             {
//                                                                 proposal.pic1 ? (
//                                                                     <a href={`https://homesafetysolutions.pythonanywhere.com${proposal.pic1}`}><img
//                                                                         className={'processImages'}
//                                                                         src={`https://homesafetysolutions.pythonanywhere.com${proposal.pic1}`}
//                                                                         alt={'prints'}/></a>) : ("No Picture")
//                                                             }
//                                                             <br/> <br/>
//                                                             {
//                                                                 proposal.pic2 ? (
//                                                                     <a href={`https://homesafetysolutions.pythonanywhere.com${proposal.pic2}`}><img
//                                                                         className={'processImages'}
//                                                                         src={`https://homesafetysolutions.pythonanywhere.com${proposal.pic2}`}
//                                                                         alt={'prints 2'}/></a>) : ("No Picture 2")
//                                                             }
//                                                             <br/> <br/>
//                                                             {
//                                                                 proposal.pic3 ? (
//                                                                     <a href={`https://homesafetysolutions.pythonanywhere.com${proposal.pic3}`}><img
//                                                                         className={'processImages'}
//                                                                         src={`https://homesafetysolutions.pythonanywhere.com${proposal.pic3}`}
//                                                                         alt={'prints 3'}/></a>) : ("No Picture 3")
//                                                             }
//                                                             <br/> <br/>
//                                                             {
//                                                                 proposal.pic4 ? (
//                                                                     <a href={`https://homesafetysolutions.pythonanywhere.com${proposal.pic4}`}><img
//                                                                         className={'processImages'}
//                                                                         src={`https://homesafetysolutions.pythonanywhere.com${proposal.pic4}`}
//                                                                         alt={"prints 4"}/></a>) : ("No Picture 4")
//                                                             }
//                                                             <br/> <br/>
//                                                             {
//                                                                 proposal.pic5 ? (
//                                                                     <a href={`https://homesafetysolutions.pythonanywhere.com${proposal.pic5}`}><img
//                                                                         className={'processImages'}
//                                                                         src={`https://homesafetysolutions.pythonanywhere.com${proposal.pic5}`}
//                                                                         alt={'prints 5'}/></a>) : ("No Picture 5")
//                                                             }
//                                                             <br/> <br/>
//                                                             {
//                                                                 proposal.pic6 ? (
//                                                                     <a href={`https://homesafetysolutions.pythonanywhere.com${proposal.pic6}`}><img
//                                                                         className={'processImages'}
//                                                                         src={`https://homesafetysolutions.pythonanywhere.com${proposal.pic6}`}
//                                                                         alt={'prints 5'}/></a>) : ("No Picture 5")
//                                                             }
//                                                             <br/> <br/>
//                                                             {
//                                                                 proposal.sign_doc_pic ? (
//                                                                     <a href={`https://homesafetysolutions.pythonanywhere.com${proposal.sign_doc_pic}`}><img
//                                                                         className={'processImages'}
//                                                                         src={`https://homesafetysolutions.pythonanywhere.com${proposal.sign_doc_pic}`}
//                                                                         alt={'prints 5'}/></a>) : ("No Signed Document Picture")
//                                                             }
//                                                             <br/>
//                                                             <br/>
//                                                             <Link className={'btn btn-info'}
//                                                                   to={`/proposal/update/${id}/`}>Update Proposal</Link>
//                                                         </div>
//                                                     </Collapse>
//                                                 </div>
//                                             )
//                                             :
//                                             (
//                                                 'Proposal Done'
//                                             )
//                                         }
//
//
//                                         <br/>
//                                         {userInfo.group !== 'Tech'
//                                             ?
//                                             (
//                                                 <div>
//                                                     <Button
//                                                         onClick={() => setInvoiceOpen(!invoiceOpen)}
//                                                         aria-controls="example-collapse-text"
//                                                         aria-expanded={invoiceOpen}
//                                                         className={'btn btn-primary'}
//                                                     >
//                                                         Invoice Details
//                                                     </Button>
//                                                     <br/>
//                                                     <Collapse in={invoiceOpen} className={'collapse-area'}>
//                                                         <div id="example-collapse-text">
//                                                             <h3>Invoice Details:</h3>
//                                                             <p>Bill amount: {invoice.bill_amount}</p>
//                                                             <p>Is Down payment made: {invoice.is_down_payment_made}</p>
//                                                             <p>Down-payment amount: {invoice.down_payment_amount}</p>
//                                                             <p>Current balance due: {invoice.current_balance_due}</p>
//                                                             <p>Payment made in full: {invoice.payment_made_in_full}</p>
//                                                             <p>Priority: {invoice.priority}</p>
//                                                             <p>Payment plan: {invoice.payment_plan}</p>
//                                                             <p>P.O.: {invoice.po}</p>
//                                                             <p>Work order number: {invoice.work_order_number}</p>
//                                                             <p>Project I.D.: {invoice.project_id}</p>
//                                                             <p>Payment notes: {invoice.payment_notes}</p>
//                                                             <br/>
//                                                             <Link className={'btn btn-info'}
//                                                                   to={`/invoice/update/${id}/`}>Update Invoice</Link>
//                                                         </div>
//                                                     </Collapse>
//                                                 </div>
//                                             )
//                                             :
//                                             (
//                                                 'Invoice Done'
//                                             )
//                                         }
//
//                                         <br/>
//
//                                         <Button
//                                             onClick={() => setWorkOrderOpen(!workOrderOpen)}
//                                             aria-controls="example-collapse-text"
//                                             aria-expanded={workOrderOpen}
//                                             className={'btn btn-primary'}
//                                         >
//                                             WorkOrder Details
//                                         </Button>
//
//                                         <br/>
//                                         <Collapse in={workOrderOpen} className={'collapse-area'}>
//                                             <div id="example-collapse-text">
//                                                 <h3>Work Order Details:</h3>
//                                                 <p>System Installed: {workOrder.system_installed}</p>
//                                                 <p>Job Completed: {workOrder.job_completed}</p>
//                                                 <p>Done: {workOrder.done}</p>
//                                                 <p>Cracked Ceiling: {workOrder.cracked_ceiling}</p>
//                                                 {
//                                                     workOrder.prevailing_wage === "Yes"
//                                                         ?
//                                                         (<p style={{background: 'red', color: "white"}}>Prevailing
//                                                             wage: {workOrder.prevailing_wage}</p>)
//                                                         :
//                                                         (<p>Prevailing wage: {workOrder.prevailing_wage}</p>)
//                                                 }
//                                                 <p>Estimated job length: {workOrder.estimated_job_length}</p>
//                                                 <p>Scheduling reviewed: {workOrder.scheduling_reviewed}</p>
//                                                 <p>Are we hiring a roofing
//                                                     company: {workOrder.are_we_hiring_a_roofing_company}</p>
//                                                 <p>Roofing company contact: {workOrder.roofing_company_contact}</p>
//                                                 <p>Are we hiring an
//                                                     electrician: {workOrder.are_we_hiring_an_electrician}</p>
//                                                 <p>Number of fans needed: {workOrder.number_of_fans_needed}</p>
//                                                 <p>Type of fan: {workOrder.type_of_fan}</p>
//                                                 <p>Work to be done: {workOrder.work_to_be_done}</p>
//                                                 <p>Notes from site: {workOrder.notes_from_site}</p>
//
//                                                 {
//                                                     workOrder.design_picture_1 ? (
//                                                         <a href={`https://homesafetysolutions.pythonanywhere.com${workOrder.design_picture_1}`}><img
//                                                             className={'processImages'}
//                                                             src={`https://homesafetysolutions.pythonanywhere.com${workOrder.design_picture_1}`}
//                                                             alt={'design picture 1'}/></a>) : ("No Design Picture")
//                                                 }
//                                                 <br/> <br/>
//                                                 {
//                                                     workOrder.design_picture_2 ? (
//                                                         <a href={`https://homesafetysolutions.pythonanywhere.com${workOrder.design_picture_2}`}><img
//                                                             className={'processImages'}
//                                                             src={`https://homesafetysolutions.pythonanywhere.com${workOrder.design_picture_2}`}
//                                                             alt={'design picture 2'}/></a>) : ("No Design Picture")
//                                                 }
//                                                 <br/> <br/>
//                                                 {
//                                                     workOrder.design_picture_3 ? (
//                                                         <a href={`https://homesafetysolutions.pythonanywhere.com${workOrder.design_picture_3}`}><img
//                                                             className={'processImages'}
//                                                             src={`https://homesafetysolutions.pythonanywhere.com${workOrder.design_picture_3}`}
//                                                             alt={'design picture 3'}/></a>) : ("No Design Picture")
//                                                 }
//                                                 <br/> <br/>
//                                                 {
//                                                     workOrder.design_picture_4 ? (
//                                                         <a href={`https://homesafetysolutions.pythonanywhere.com${workOrder.design_picture_4}`}><img
//                                                             className={'processImages'}
//                                                             src={`https://homesafetysolutions.pythonanywhere.com${workOrder.design_picture_4}`}
//                                                             alt={'design picture 4'}/></a>) : ("No Design Picture")
//                                                 }
//                                                 <br/> <br/>
//                                                 {
//                                                     workOrder.design_picture_5 ? (
//                                                         <a href={`https://homesafetysolutions.pythonanywhere.com${workOrder.design_picture_5}`}><img
//                                                             className={'processImages'}
//                                                             src={`https://homesafetysolutions.pythonanywhere.com${workOrder.design_picture_5}`}
//                                                             alt={'design picture 5'}/></a>) : ("No Design Picture")
//                                                 }
//                                                 <br/>
//                                                 <Link className={'btn btn-info'} to={`/workorder/update/${id}/`}>Update
//                                                     Work Order</Link>
//                                             </div>
//                                         </Collapse>
//                                         <br/>
//
//                                         <Button
//                                             onClick={() => setHoursWorkedOpen(!hoursWorkedOpen)}
//                                             aria-controls="example-collapse-text"
//                                             aria-expanded={hoursWorkedOpen}
//                                             className={'btn btn-primary'}
//                                         >
//                                             Hours Details
//                                         </Button>
//                                         <br/>
//                                         <Collapse in={hoursWorkedOpen} className={'collapse-area'}>
//                                             <div id="example-collapse-text">
//                                                 <h3>Hours Worked:</h3>
//                                                 {workHours.map(hour =>
//                                                     <div key={hour.client}>
//                                                         <p>Hours
//                                                             Created: {Moment(hour.created).format("MM/DD/YYYY")}</p>
//                                                             <Row>
//                                                                 <Col>
//                                                                     <Link className={'btn btn-info'}
//                                                                           to={`/workhour/${hour.id}/`}>
//                                                                         Detail Hours
//                                                                     </Link>
//                                                                 </Col>
//                                                                 <Col>
//                                                                     <Link className={'btn btn-warning'}
//                                                                           to={`/workhour/update/${hour.id}/`}>
//                                                                         Update Hours
//                                                                     </Link>
//                                                                 </Col>
//                                                             </Row>
//                                                         <br />
//                                                     </div>
//                                                 )}
//                                                 <br/>
//                                             </div>
//                                         </Collapse>
//
//                                     </Col>
//                                 </Row>
//                             </div>
//                         )
//                 }
//             </div>
//
//         </div>
//     );
// };
//
// export default SearchResults;
